// extracted by mini-css-extract-plugin
export default {"AvatarContainer":"Avatar_AvatarContainer__3SaqO","AvatarWrapper":"Avatar_AvatarWrapper__Zkcg6","NoImage":"Avatar_NoImage__gaSa0"};